'use strict';
var globalThis = require('../internals/global-this');

module.exports = globalThis;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/path.js
// module id = 230
// module chunks = 0